
export const getInitials = (name = "") => {
    const names = name.split(" ");
    return names
      .map((n) => n[0]?.toUpperCase() || "")
      .join("")
      .slice(0, 2);
  };
  
  // Generate consistent color from name
  export const getColorFromName = (name = "") => {
    const colors = ["#4e73df", "#1cc88a", "#36b9cc", "#f6c23e", "#e74a3b"];
    const hash = name.split("").reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    return colors[hash % colors.length];
  };